
import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import Sessions from "@/components/Sessions.vue";
import ViewController from "@/components/views/ViewController.vue";
import ViewHeader from "@/components/views/ViewHeader.vue";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";
import ViewsEventBus from "@/services/views/viewsEventBus";
import ManualRaise from "@/components/ManualRaise.vue";

/**
 * Expose our framework modules globally, so our view plugins can access them
 * without needing to bundle them with the plugin itself.
 **/
import "@/scripts/WindowExports";

const ViewState = namespace("views");

@Component({
	components: {
		"view-header": ViewHeader,
		session: Sessions,
		"view-controller": ViewController,
		"manual-raise": ManualRaise,
	},
})
export default class Views extends Vue {
	@ViewState.Action loadPluginTypes: any;
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	@Provide("viewsEventBus") private eventBus: ViewsEventBus = new ViewsEventBus();

	public async mounted() {
		if (this.isMobileViewsEnabled) {
			await this.loadPluginTypes();
		}
	}

	public get isMobileViewsEnabled() {
		return this.getFeature(["Mobile", "Views"]);
	}
}
